import { rowColumn, tableOptions } from "../../../components/table/Table";
import { getFilterOptions } from "../../CommonFunctions";
import { assignStatusPrimaryOptions, assignStatusSecondaryOptions } from "../../formObjects/application/assignStatusForm";

export const childCheckerListTable = (currPath: string): rowColumn[] => [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
    frozen: true,
  },
  {
    label: "Year",
    column: "yearApplied",
    type: "string",
    sortOn: "YearApplied",
  },
  {
    label: "Application Type",
    column: "typeOfApplication",
    type: "string",
    sortOn: "TypeOfApplication",
    body: (rowData) => {
      return <p className="m-0">{rowData.typeOfApplication === null ? "New" : rowData.typeOfApplication === 0 ? "Appeal" : "Transfer"}</p>;
    },
  },
  {
    label: "Appeal #",
    column: "applicationNumber",
    type: "string",
    sortOn: "ApplicationNumber",
    body: (rowData) => {
      return <p className="m-0">{rowData.typeOfApplication === 0 ? rowData.applicationNumber : ""}</p>;
    },
  },
  {
    label: "Eligible",
    column: "isApplicationEligible",
    type: "string",
    sortOn: "IsApplicationEligible",
    isFilter: true,
    filterType: "multiselect",
    filterElements: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
    body: (rowData) => {
      return <p className="m-0">{rowData.isApplicationEligible}</p>;
    },
  },
  {
    label: "AA Child",
    type: "string",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.additionalAssistant == null
            ? null
            : rowData.additionalAssistantSupportApproved === 1 && rowData.additionalAssistant === true
              ? rowData.hoursAllocatedToChild
              : "No"}
        </p>
      );
    },
  },
  {
    label: "AA Group",
    type: "string",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.additionalAssistant == null
            ? null
            : rowData.additionalAssistantSupportApproved === 1 && rowData.additionalAssistant === true
              ? rowData.hoursAllocatedForGroupComplexity
              : "No"}
        </p>
      );
    },
  },
  {
    label: "AA Total",
    type: "string",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.additionalAssistant == null
            ? null
            : rowData.additionalAssistantSupportApproved === 1 && rowData.additionalAssistant === true
              ? rowData.totalHoursAllocated
              : "No"}
        </p>
      );
    },
  },
  {
    label: "Kinder",
    column: "fundedKinderName",
    type: "string",
    sortOn: "FundedKinderName",
    body: (rowData) => {
      return <p className="m-0">{rowData.fundedKinderName === "Other" ? rowData.kindergartenNameOther : rowData.fundedKinderName}</p>;
    },
  },
  {
    label: "Status",
    column: "statusComputed",
    type: "string",
    sortOn: "StatusComputed",
    isFilter: true,
    filterType: "multiselect",
    filterElements: getFilterOptions(assignStatusPrimaryOptions, assignStatusSecondaryOptions, [
      { secondaryOption: "Presubmission" },
      { secondaryOption: "Withdrawn" },
      { secondaryOption: "Unable to process" },
      { secondaryOption: "Add Info not received" },
    ]),
  },
  {
    label: "Actions",
    body: (rowData) => <a href={`${currPath}/${rowData.discriminator}/${rowData.id}`}>View Details</a>,
  },
];

export const childCheckerOptions: tableOptions = {
  sortField: undefined,
  sortOrder: undefined,
  sortColumn: "Id",
  sortDirection: "desc",
};
